module.exports = __webpack_public_path__ + "static/media/icn_fundwise_summary.1a922133.svg";